module.exports = __webpack_public_path__ + "static/img/sites.bd60599.svg";